import { CheckIcon, WarningTwoIcon } from '@chakra-ui/icons';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  chakra,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

import ApplicationList from './ApplicationList';
import SubscribeForm from './SubscribeForm';
import styled from '@emotion/styled';

type STEP_NAME = 'SUBSCRIBE' | 'SUBSCRIBE_SUCCESS' | 'SUBSCRIBE_ERROR';

const WarningIconWrapperStyles = chakra(WarningTwoIcon, {
  baseStyle: {
    color: '#E94860',
  },
});
const CheckIconWrapperStyles = styled.span`
  background: #1ba97f;
  display: inline-flex;
  border-radius: 50%;
  padding: 14px;
`;

const stepConfig: {
  SUBSCRIBE: STEP_NAME;
  SUBSCRIBE_SUCCESS: STEP_NAME;
  SUBSCRIBE_ERROR: STEP_NAME;
} = {
  SUBSCRIBE: 'SUBSCRIBE',
  SUBSCRIBE_SUCCESS: 'SUBSCRIBE_SUCCESS',
  SUBSCRIBE_ERROR: 'SUBSCRIBE_ERROR',
};

const modalContentConfig = {
  SUBSCRIBE: {
    modalHeader: () => {
      return (
        <ModalHeader
          p={0}
          color='primary.100'
          fontWeight={600}
          className='!text-2xl md:!text-[46px]'
        >
          Inscribirme
        </ModalHeader>
      );
    },
    modalBody: (setNextStep?: (step: STEP_NAME) => void) => {
      return (
        <ModalBody p={0}>
          <Text
            fontWeight={400}
            fontSize='18px'
            className='mt-4 mb-6 md:mt-6 md:mb-8'
            color='primary.100'
          >
            Por favor escriba su e-mail para ver los enlaces de descarga.
          </Text>
          <SubscribeForm setNextStep={setNextStep} />
        </ModalBody>
      );
    },
  },
  SUBSCRIBE_SUCCESS: {
    modalHeader: () => {
      return (
        <ModalHeader
          p={0}
          color='primary.100'
          fontWeight={600}
          className='!text-2xl md:!text-[46px] flex items-center'
        >
          <CheckIconWrapperStyles>
            <CheckIcon color='white' w={4} h={4} />
          </CheckIconWrapperStyles>
          <Text ml={3}>Gracias</Text>
        </ModalHeader>
      );
    },
    modalBody: () => {
      return (
        <ModalBody p={0}>
          <Text fontWeight={400} fontSize='20px' my={8} color='primary.100'>
            Descargue la aplicación
          </Text>
          <ApplicationList />
        </ModalBody>
      );
    },
  },
  SUBSCRIBE_ERROR: {
    modalHeader: () => {
      return (
        <ModalHeader
          p={0}
          color='primary.100'
          fontWeight={600}
          fontSize='42px'
          className='flex items-center !text-2xl md:!text-[42px]'
        >
          <WarningIconWrapperStyles>
            <WarningTwoIcon />
          </WarningIconWrapperStyles>
          <Text ml={3} className='text-[#E94860]'>
            Error
          </Text>
        </ModalHeader>
      );
    },
    modalBody: () => {
      return (
        <ModalBody p={0}>
          <Text fontWeight={400} fontSize='16px' my={8} color='primary.100'>
            Ha ocurrido un error realizando la suscripción.
            <br /> Por favor, inténtelo de nuevo
          </Text>
        </ModalBody>
      );
    },
  },
};

const SubscriptionModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => {
  const [step, setStep] = useState<STEP_NAME>(stepConfig.SUBSCRIBE);
  useEffect(() => {
    if (isOpen === false) {
      setStep('SUBSCRIBE');
    }
  }, [isOpen]);
  return (
    <>
      <Modal onClose={onClose} isOpen={isOpen} isCentered size={'xl'}>
        <ModalOverlay />
        <ModalContent p={8}>
          {modalContentConfig[step].modalHeader()}
          <ModalCloseButton color='primary.100' size='lg' onClick={onClose} />
          {modalContentConfig[step].modalBody(setStep)}
        </ModalContent>
      </Modal>
    </>
  );
};

export default SubscriptionModal;
